const styles = {
  control: baseStyles => ({
    ...baseStyles,
    background: 'var(--bs-body-bg)',
    color: 'var(--bs-body-color)',
    borderColor: 'var(--bs-border-color)'
  }),
  input: baseStyles => ({
    ...baseStyles,
    color: 'var(--bs-body-color)'
  }),
  menuPortal: baseStyles => ({
    ...baseStyles,
    zIndex: 99_999
  }),
  menu: baseStyles => ({
    ...baseStyles,
    background: 'var(--bs-body-bg)',
    color: 'var(--bs-body-color)'
  }),
  menuList: (baseStyles, state) => ({
    ...baseStyles,
    background: state.isFocused ? 'var(--bs-blue)' : 'var(--bs-body-bg)',
    color: 'var(--bs-body-color)'
  }),
  singleValue: baseStyles => ({
    ...baseStyles,
    color: 'var(--bs-body-color)'
  }),
  multiValue: baseStyles => ({
    ...baseStyles,
    color: 'var(--bs-body-color)'
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    background: state.isFocused ? 'var(--bs-primary-border-subtle)' : 'var(--bs-body-bg)',
    color: 'var(--bs-body-color)'
  })
};

export default styles;
